import type { ContactData } from "@/types/contact";

export const DEFAULT_CONTACT_DATA: ContactData = {
  reprezentantLegal: {
    nume: "",
    prenume: "",
    functie: "",
    telefon: "",
    email: "",
  },
  responsabilSecuritate: {
    nume: "",
    prenume: "",
    functie: "",
    telefon: "",
    email: "",
  },
  contactOperational: {
    nume: "",
    prenume: "",
    functie: "",
    telefon: "",
    email: "",
  },
  adreseIP: [""],
  sistemeAfectate: "",
  confirmaExactitate: false,
  acceptaObligatii: false,
};
